// client/hooks/widgets/useViewportTier.js
// ✅ Hook für Viewport-Tier (bestimmt wie viele Rails möglich sind)
import { useMemo } from "react";
import { useViewportWidth } from "../useResponsive.js";

// Breakpoints
const SINGLE_RAIL_MIN = 1280; // xl - Eine Rail möglich
const DUAL_RAIL_MIN = 1536;   // 2xl - Beide Rails möglich

/**
 * Viewport-Tiers:
 * - "none": Unter 1280px - Keine Widget-Rails
 * - "single": 1280-1535px - Eine Rail (links ODER rechts)
 * - "dual": Ab 1536px - Beide Rails möglich
 */
export const VIEWPORT_TIERS = {
  NONE: "none",
  SINGLE: "single",
  DUAL: "dual",
};

/**
 * Hook ermittelt aktuellen Viewport-Tier
 * @returns {{ tier: string, canShowLeft: boolean, canShowRight: boolean, canShowBoth: boolean }}
 */
export function useViewportTier() {
  const width = useViewportWidth();

  const result = useMemo(() => {
    let tier = VIEWPORT_TIERS.NONE;

    if (width >= DUAL_RAIL_MIN) {
      tier = VIEWPORT_TIERS.DUAL;
    } else if (width >= SINGLE_RAIL_MIN) {
      tier = VIEWPORT_TIERS.SINGLE;
    }

    return {
      tier,
      width,
      canShowLeft: tier !== VIEWPORT_TIERS.NONE,
      canShowRight: tier !== VIEWPORT_TIERS.NONE,
      canShowBoth: tier === VIEWPORT_TIERS.DUAL,
      isSingleOnly: tier === VIEWPORT_TIERS.SINGLE,
    };
  }, [width]);

  return result;
}

export default useViewportTier;
